import web from "../web";

class UsersService {
    index(token){
        return web.get("/api/users", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/users/inscription", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/users/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/users/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/users/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    //get role_user 
    getRoleUser(id, token){
        return web.get(`/api/role_users/${id}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new UsersService()